export default "__VITE_ASSET__a40b39df__"